import type { ComponentType } from '@/services/api/generated/correspondenceService';

/**
 * Human-readable labels for correspondence component types
 */
export const ComponentTypeLabels: Record<ComponentType, string> = {
  template: 'Template',
  global_template: 'Global Template',
  matter_blob: 'Matter Document',
  static_document: 'Static Document',
  external_file: 'External File',
  generated_content: 'Generated Content',
  merge_document: 'Merge Document',
  signed_authorization_merge: 'Signed Authorization',
};
